import React from 'react';
import { twMerge } from 'tailwind-merge';

const BaseButton = ({
    type = 'button',
    id,
    className,
    loadingClassName,
    disabled = false,
    isLoading = false,
    textValue,
    children,
    onClick,
    onMouseDown,
    onMouseUp,
    onMouseLeave,
    onTouchStart,
    onTouchEnd,
    onTouchCancel
}) => {
    const classes = twMerge('p-4 rounded-4xl text-lg font-bold leading-4.5 w-full', className);

    return (
        <button
            type={type}
            id={id}
            className={classes}
            disabled={disabled}
            onClick={onClick}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            onMouseLeave={onMouseLeave}
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
            onTouchCancel={onTouchCancel}
        >
            {textValue && isLoading && <span className={loadingClassName}>{textValue}...</span>}
            {textValue && !isLoading && textValue}
            {!textValue && children}
        </button>
    );
};

export default BaseButton;
